import React, { useEffect, useState } from 'react';
import { Box, Paper, Typography, Chip } from '@mui/material';
import './Announcements.css';

const Announcements = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [events, setEvents] = useState([]);

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const response = await fetch('https://backend-school-914b.onrender.com/announcements');
        const data = await response.json();
        setAnnouncements(data);
      } catch (error) {
        console.error('Failed to fetch announcements:', error);
      }
    };

    const fetchEvents = async () => {
      try {
        const response = await fetch('https://backend-school-914b.onrender.com/events');
        const data = await response.json();
        setEvents(data);
      } catch (error) {
        console.error('Failed to fetch events:', error);
      }
    };

    fetchAnnouncements();
    fetchEvents();
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        justifyContent: 'space-around',
        padding: '20px',
        gap: { xs: 3, md: 0 },
      }}
    >
      {/* Announcements Box */}
      <Box sx={{ width: { xs: '100%', md: '45%' }, position: 'relative' }}>
        {/* Heading */}
        <Typography
          variant="h6"
          sx={{
            position: 'absolute',
            top: '-15px',
            width: '100%',
            backgroundColor: '#fff4e6',
            zIndex: 1,
            textAlign: 'center',
            borderRadius: '10px',

          }}
        >
          Announcements
        </Typography>
        {/* Scrollable Paper */}
        <Paper
          sx={{
            height: '300px',
            padding: '15px',
            backgroundColor: '#fff4e6',
            borderRadius: '10px',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              overflowY: 'hidden',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
              animation: 'scrollUp 15s linear infinite',
            }}
          >
            {announcements.length > 0 ? (
              announcements.map((announcement, index) => (
                <Chip key={index} label={announcement.text} color="primary" />
              ))
            ) : (
              <Typography>No Announcements</Typography>
            )}
          </Box>
        </Paper>
      </Box>

      {/* Events Box */}
      <Box sx={{ width: { xs: '100%', md: '45%' }, position: 'relative' }}>
        {/* Heading */}
        <Typography
          variant="h6"
          sx={{
            position: 'absolute',
            top: '-15px',
            width: '100%',
            backgroundColor: '#fff4e6',
            zIndex: 1,
            textAlign: 'center',
            borderRadius: '10px',

          }}
        >
          Upcoming Events
        </Typography>
        {/* Scrollable Paper */}
        <Paper
          sx={{
            height: '300px',
            padding: '15px',
            backgroundColor: '#fff4e6',
            borderRadius: '10px',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              overflowY: 'hidden',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
              animation: 'scrollUp 15s linear infinite',
            }}
          >
        {events.length > 0 ? (
  events.map((event, index) => (
    <Chip 
      key={index} 
      label={
        <Typography>
          <b>{new Date(event.date).toLocaleDateString()}</b> - {event.description}
        </Typography>
      } 
      color="primary" 
    />
  ))
) : (
  <Typography>No Events</Typography>
)}

          </Box>
        </Paper>
      </Box>
    </Box>
  );
};

export default Announcements;
